module.exports = __webpack_public_path__ + "img/result-3V.38e94819.png";